import { isUndefinedOrNull } from '../../../TypeHelpers';
export default function singleOrDefault(enumerable, predicate) {
    if (!isUndefinedOrNull(predicate)) {
        enumerable = enumerable.where(predicate);
    }
    const en = enumerable.take(2).getEnumerator();
    let returnValue;
    while (en.moveNext()) {
        if (!isUndefinedOrNull(returnValue)) {
            // TODO: should this throw here?  throw new InvalidOperationException("More than one match in the collection!");
            return null;
        }
        returnValue = en.current;
    }
    if (isUndefinedOrNull(returnValue)) {
        return null;
    }
    return returnValue;
}
